
import React from 'react'
import { Container } from 'react-bootstrap';
import shippingImg from "../Assets/img/shipping_advance.svg";
import moneyImg from "../Assets/img/money_advance.svg";
import supportImg from "../Assets/img/support_advance.svg";
import flexibleImg from "../Assets/img/flexible_advace.svg";
import Heading from '../ui/Heading';

const AdvantageMont = () => {
    return (
        <section className='advancetag_section section-space'>
            <Container fluid className='mx-1440 text-center'>
                <Heading className="text-center">
                    <h2>Advantages Of Montgomery Jewelers</h2>
                    <p>We’ll be available for you anytime and anywhere</p>
                </Heading>

                <div className='advancetag_grid'>
                    <div className="advancetag_grid_items">
                        <div className='icon_wrap'>
                            <img src={shippingImg} alt="Shipping" />
                        </div>
                        <div className='advancetag_grid_items_text'>
                            <h4>Free Shipping</h4>
                            <p>Free Shipping for orders over £130</p>
                        </div>
                    </div>
                    <div className="advancetag_grid_items">
                        <div className='icon_wrap'>
                            <img src={moneyImg} alt="Money" />
                        </div>
                        <div className='advancetag_grid_items_text'>
                            <h4>Money Guarantee</h4>
                            <p>Within 30 days for an exchange.</p>
                        </div>
                    </div>
                    <div className="advancetag_grid_items">
                        <div className='icon_wrap'>
                            <img src={supportImg} alt="Support" />
                        </div>
                        <div className='advancetag_grid_items_text'>
                            <h4>24/7 online support</h4>
                            <p>24 hours a day, 7 days a week</p>
                        </div>
                    </div>
                    <div className="advancetag_grid_items">
                        <div className='icon_wrap'>
                            <img src={flexibleImg} alt="flexible" />
                        </div>
                        <div className='advancetag_grid_items_text'>
                            <h4>Flexible Payment</h4>
                            <p>Pay with Multiple Credit Cards</p>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default AdvantageMont